module.exports = __webpack_public_path__ + "img/avatar7.2a820532.png";